import { Typography } from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import messages from './messages';

const Footer = () => {
  return (
    <Typography variant='subtitle2'>
      &copy;&nbsp;{new Date().getFullYear()}&nbsp;
      <FormattedMessage {...messages.copy} />
    </Typography>
  );
};

export default Footer;
